import React, { Component } from 'react';
import { Box } from '@mui/material';
import SectionTitle from './SectionTitle';
import RadioButtonGroup from '../../../../../components/RadioButtonGroup';
import SelectableChip from '../../../../../components/SelectableChip';
import { ALERT_SEVERITY } from '../../../../../components/AlertDisplay2';

export const PAYMENT_METHOD_TYPE = {
    CASH: 'Cash',
    CARD: 'Card',
    ONLINE: 'Online',
    GIFTCARD: 'Giftcard',
    PAYPAL: 'PayPal',
};

export const PAYMENT_METHOD_RESTRICTION_SELECTION_TYPES = {
    NO_RESTRICTIONS: 'NO_RESTRICTION_PAYMENT',
    ONLY_SELECTED: 'ONLY_SELECTED_PAYMENTS',
};

class PaymentMethodConfigSection extends Component {
    constructor(props) {
        super(props);

        this.paymentSelectionTypes = [
            { key: PAYMENT_METHOD_RESTRICTION_SELECTION_TYPES.NO_RESTRICTIONS, label: 'Keine Einschränkung' },
            { key: PAYMENT_METHOD_RESTRICTION_SELECTION_TYPES.ONLY_SELECTED, label: 'Nur ausgewählte Zahlungsmethoden' },
        ];
    }

    getPaymentLabel = (type) => {
        switch (type) {
            case PAYMENT_METHOD_TYPE.CASH:
                return 'Barzahlung';
            case PAYMENT_METHOD_TYPE.CARD:
                return 'Karte';
            case PAYMENT_METHOD_TYPE.ONLINE:
                return 'Online';
            case PAYMENT_METHOD_TYPE.GIFTCARD:
                return 'Gutschein';
            case PAYMENT_METHOD_TYPE.PAYPAL:
                return 'PayPal';
            default:
                return type;
        }
    };

    togglePaymentMethod = (type) => {
        const {
            selectedPaymentMethods = [],
            selectedOption,
            setSelectedOption,
            setSelectedPaymentMethods,
            editMode,
        } = this.props;

        let mySelected = [...selectedPaymentMethods];
        const idx = mySelected.findIndex((pm) => pm.type === type);

        if (idx > -1) {
            if (!editMode || mySelected[idx].added) {
                mySelected.splice(idx, 1);
            } else {
                this.props.showAlert?.('Die Daten können nicht bearbeitet werden.', ALERT_SEVERITY.WARNING);
                return;
            }
        } else {
            if (selectedPaymentMethods.length === Object.keys(PAYMENT_METHOD_TYPE).length - 1) {
                mySelected = editMode ? mySelected.filter((pm) => !pm.added) : [];

                setSelectedOption?.({
                    ...selectedOption,
                    ...(editMode
                        ? { newSelectionType: PAYMENT_METHOD_RESTRICTION_SELECTION_TYPES.NO_RESTRICTIONS }
                        : { selectionType: PAYMENT_METHOD_RESTRICTION_SELECTION_TYPES.NO_RESTRICTIONS }),
                });
            } else {
                mySelected.push(editMode ? { type, added: true } : { type });
            }
        }

        setSelectedPaymentMethods?.(mySelected);
    };

    render() {
        const {
            selectedPaymentMethods = [],
            setSelectedPaymentMethods,
            selectedOption,
            setSelectedOption,
            editMode,
        } = this.props;

        const selectionType = selectedOption?.newSelectionType ?? selectedOption?.selectionType;

        return (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                <SectionTitle
                    icon={require('../../../../../assets/icons/onlinepayment.png')}
                    label="Zahlungsmethoden"
                />

                <RadioButtonGroup
                    items={this.paymentSelectionTypes}
                    selectedKey={selectionType}
                    onSelect={(item) => {
                        if (editMode) {
                            if (item === PAYMENT_METHOD_RESTRICTION_SELECTION_TYPES.NO_RESTRICTIONS) {
                                setSelectedOption?.({ ...selectedOption, newSelectionType: item });
                            } else if (
                                item === PAYMENT_METHOD_RESTRICTION_SELECTION_TYPES.ONLY_SELECTED &&
                                selectedOption?.newSelectionType === PAYMENT_METHOD_RESTRICTION_SELECTION_TYPES.NO_RESTRICTIONS
                            ) {
                                const myOption = { ...selectedOption };
                                delete myOption.newSelectionType;
                                setSelectedOption?.(myOption);
                            } else {
                                this.props.showAlert?.('Die Daten können nicht bearbeitet werden.', ALERT_SEVERITY.WARNING);
                            }
                        } else {
                            setSelectedOption?.({ ...selectedOption, selectionType: item });

                            if (item === PAYMENT_METHOD_RESTRICTION_SELECTION_TYPES.NO_RESTRICTIONS) {
                                setSelectedPaymentMethods?.([]);
                            }
                        }
                    }}
                />

                {selectionType === PAYMENT_METHOD_RESTRICTION_SELECTION_TYPES.ONLY_SELECTED && (
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.75 }}>
                        {Object.keys(PAYMENT_METHOD_TYPE).map((key) => {
                            const type = PAYMENT_METHOD_TYPE[key];
                            const selected = selectedPaymentMethods.some((pm) => pm.type === type);

                            return (
                                // <div style={{ display: 'flex', gap: 8 }} key={key}>
                                <SelectableChip
                                    key={key}
                                    label={this.getPaymentLabel(type)}
                                    value={selected}
                                    onPress={() => this.togglePaymentMethod(type)}
                                />
                                // </div>
                            );
                        })}
                    </Box>
                )}
            </Box>
        );
    }
}

export default PaymentMethodConfigSection;